import { currency } from "./currency";

export function priceDifference(oldPrice, newPrice, locale: string | undefined) {
  const percentage = ((oldPrice - newPrice) / oldPrice) * 100;
  if (percentage <= 10) {
    return `${percentage.toFixed(0)}%`;
  }
  const priceDiff = oldPrice - newPrice;

  return currency(priceDiff, locale);
}

export function savingsPercentage(oldPrice: number, newPrice: number) {
  const percentage = ((oldPrice - newPrice) / oldPrice) * 100;
  return `-${percentage.toFixed(0)}%`;
}
